"use client";

import React from "react";
import { Card, Typography, List, ListItem, Box, Chip } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";

const SpokeLeaderboard = ({ data = [] }) => {
    return (
        <Card
            sx={{
                boxShadow: "none",
                borderRadius: "7px",
                p: { xs: 2, sm: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Typography variant="h6" fontWeight={700} mb={2}>
                Client Leaderboard
            </Typography>
            <Box sx={{
                flexGrow: 1,
                overflowY: "auto",
                maxHeight: 380,
                pr: 1, // Add some padding right so content doesn't touch scrollbar
                "&::-webkit-scrollbar": {
                    width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                    background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#EAECF0", // Use a subtle gray from the theme
                    borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#D0D5DD",
                },
                // For Firefox
                scrollbarWidth: "thin",
                scrollbarColor: "#EAECF0 transparent"
            }}>
                <List disablePadding>
                    {data.map((client, index) => (
                        <ListItem
                            key={client.id || index}
                            divider={index < data.length - 1}
                            sx={{ px: 0, py: 1.5 }}
                        >
                            <Box flex={1}>
                                <Typography variant="subtitle2" fontWeight={600}>
                                    {client.name}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Revenue: ${client.revenue?.toLocaleString()}
                                </Typography>
                            </Box>
                            <Chip
                                icon={<StorefrontIcon sx={{ fontSize: 16 }} />}
                                label={`${client.stores} Stores`}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ borderRadius: "6px" }}
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Card>
    );
};

export default SpokeLeaderboard;
